import { Component, EventEmitter, Input, Output } from '@angular/core';
import { animate, AnimationEvent, state, style, transition, trigger } from '@angular/animations';
import { FeedbackSettings } from './feedback-settings';
import { FeedbackType } from './feedback-type';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss'],
  animations: [
    trigger('fade', [
      state('false', style({ opacity: 1 })),
      state('true', style({ opacity: 0 })),
      transition('false => true', animate('2000ms ease-out')),
    ]),
  ],
})
export class FeedbackComponent {
  @Input() settings: FeedbackSettings = {
    identifier: '',
    show: false,
    type: FeedbackType.success,
    message: '',
    closeButton: false,
  };

  @Output() settingsChange = new EventEmitter<FeedbackSettings>();

  @Output() update = new EventEmitter<string>();

  public fadeOutStart = false;

  showFeedback(
    identifier: string,
    type: FeedbackType,
    message: string,
    buttonText: string | undefined,
    closeButton: boolean
  ): void {
    this.settings = {
      identifier,
      type,
      show: true,
      message,
      buttonText,
      closeButton,
    };
  }

  hide() {
    this.settings.show = false;
    this.settingsChange.emit(this.settings);
  }

  feedbackType() {
    return FeedbackType;
  }

  sendUpdate() {
    this.update.emit(this.settings.identifier);
  }

  fadeOut(delay: number = 0) {
    setTimeout(() => {
      this.fadeOutStart = true;
    }, delay);
  }

  animationDone($event: AnimationEvent) {
    if ($event.toState) {
      this.hide();
      this.fadeOutStart = false;
    }
  }
}
